import Typography from "components/basic/typography";
import { useTranslation } from "react-i18next";
import { translateOptions } from "../../helpers/optionLabels";
import GarageChargerImage from "resources/images/GarageChargerImage.png";
import { useNavigate } from "react-router-dom";
import AutoComplete from "components/basic/autoComplete";
import { useSnack } from "hooks/useSnack";
import { ChargerEstimatorToolsPagesProps } from "pages/chargerEstimator";
import FormPageLayout from "components/basic/formPageLayout";
import { useTheme } from "@mui/material";

const VEHICLE_OPTIONS = [
  { id: 1, label: "Tesla" },
  { id: 2, label: "Other" },
];

const VehicleTypePage: React.FC<ChargerEstimatorToolsPagesProps> = ({
  chargerEstimatorData,
  setChargerEstimatorData,
}) => {
  const navigate = useNavigate();
  const showSnack = useSnack();
  const theme = useTheme();
  const { t } = useTranslation("estimator");

  const vehicleType = chargerEstimatorData.vehicleType
    ? {
        id: chargerEstimatorData.vehicleType === "Tesla" ? 1 : 2,
        label: chargerEstimatorData.vehicleType,
      }
    : null;

  const handleNext = () => {
    if (!chargerEstimatorData.vehicleType) {
      showSnack(t("vehicle.required"), "error");
      return;
    }
    navigate("?currentPage=homeSetup");
  };

  return (
    <FormPageLayout
      imageSrc={GarageChargerImage}
      imageAlt={t("vehicle.image_alt")}
      imagePosition="right"
      title={
        <Typography
          style={{ fontWeight: "bold", fontSize: "2.5em" }}
          variant="h2"
          align="inherit"
        >
          {t("vehicle.title")}
        </Typography>
      }
      backAction={{
        label: t("nav.back"),
        color: "primary",
        onClick: () => navigate("?currentPage="),
      }}
      primaryAction={{
        label: t("nav.next"),
        color: "warning",
        onClick: handleNext,
      }}
    >
      <div style={{ marginTop: `${theme.spacing(1)}` }}>
        <AutoComplete
          name="vehicleType"
          value={vehicleType?.id || null}
          options={translateOptions(t, VEHICLE_OPTIONS)}
          label={t("nav.please_select")}
          onChange={(value) =>
            setChargerEstimatorData({
              ...chargerEstimatorData,
              vehicleType:
                VEHICLE_OPTIONS.find((o) => o.id === value?.id)?.label || "",
            })
          }
          size="tiny"
          textAlign="center"
        />
      </div>
    </FormPageLayout>
  );
};

export default VehicleTypePage;
